<template>
  <div class="info-wrap">
    <div v-for="(item,index) in data.propertyGroups" :key="index">
      <div v-if="item.name.indexOf('BasicInformation') > -1">
        <p style="padding: 0px;margin: 0px;">{{item.displayName}}</p>
        <div style="display: flex;flex-flow: wrap;">
          <div v-for="(obj,index) in item.properties" :key="index+'a'" style="padding-right: 10px;" v-show="obj.name !=='shield' && obj.name !=='isVirtual' && obj.name.indexOf('benchmarking') == -1">
            <label>{{obj.displayName}}:</label>
            <label class="red">{{obj.value}}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../../../../common/api/index";
export default {
  props: {
    measureId: {
      type: String,
      default: "",
    },
  },
  data () {
    return {
      data: [],
      enumData: [],
    };
  },
  watch: {
    measureId (val) {
      this.getMeasuresProperties2(val);
    },
  },
  created () {
    api.enumClass.getSubEnumClasses2("", 0, this.$store.state.user.currentCompanyId).then((res) => {
      this.enumData = res.data;
      if (this.measureId.length > 0) {
        this.getMeasuresProperties2(this.measureId);
      }
    });
  },
  methods: {
    getMeasuresProperties2 (id) {
      api.measure.getMeasuresProperties2(JSON.stringify([id])).then((res) => {
        if (res.data.length > 0) {
          for (
            let index = 0;
            index < res.data[0].propertyGroups.length;
            index++
          ) {
            for (
              let j = 0;
              j < res.data[0].propertyGroups[index].properties.length;
              j++
            ) {
              if (
                res.data[0].propertyGroups[index].properties[j].regulation
                  .valueType == 5
              ) {
                const item = this.enumData.find(
                  (c) =>
                    c.name ==
                    res.data[0].propertyGroups[index].properties[j].value
                );
                if (item) {
                  res.data[0].propertyGroups[index].properties[j].value =
                    item.displayName;
                }
              }
            }
          }
          this.data = res.data[0];
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.info-wrap {
  padding: 10px;
  min-height: 14px;
}
.red {
  color: #ed6a93;
  background: transparent;
}
</style>